const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// In-memory token reference (set by AuthContext on login)
let _tokenRef = null;

export const setTokenGetter = (getter) => { _tokenRef = getter; };

export const authFetch = (url, options = {}) => {
  const token = _tokenRef ? _tokenRef() : null;
  const headers = { ...options.headers };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers, credentials: 'include' });
};

export const apiFetch = (path, options = {}) => {
  return authFetch(`${API_URL}${path}`, options);
};

export { API_URL };
